<template>
  <a :class="classObject" @click.prevent.stop="$emit('click')" href="#">
    <icon width="14" height="14" :name="icon" :fill="iconFill"></icon>
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'dropdown-action',

  props: {
    icon: String,
    iconFill: {
      type: Boolean,
      default: true
    },
    danger: Boolean,
    success: Boolean,
  },

  computed: {
    classObject() {
      return {
        'c-dropdown__action': true,
        'c-dropdown__action--success': this.success,
        'c-dropdown__action--danger': this.danger,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-dropdown__action {

  &--success {
    color: $colour-nhs-dark-green;
  }

  &--danger {
    color: $colour-nhs-emergency-red;
  }

  svg {
    path {
      stroke: inherit;
    }
  }
}
</style>
